export { readingTime } from './reading';
export function arraySumNext(array) {
    const copy = [...array];
    const len = copy.length;
    for (let i = len - 1; i >= 0; i -= 1) {
        if (i + 1 < len) {
            copy[i] += copy[i + 1]; // eslint-disable-line no-param-reassign
        }
    }
    return copy;
}
/* search for the highest z-index in the document */
export function maxIndex() {
    let highestZindex = 0;
    const forEach = (array, callback) => {
        for (let i = 0; i < array.length; i += 1) {
            callback(i, array[i]);
        }
    };
    const elements = [];
    forEach(document.querySelectorAll('*'), (index, element) => {
        const zindex = getComputedStyle(element).getPropertyValue('z-index');
        if (['auto', 0].indexOf(zindex) === -1 && parseInt(zindex, 10) >= highestZindex) {
            elements.push({ zindex: parseInt(zindex, 10), element });
            highestZindex = parseInt(zindex, 10);
        }
    });
    return highestZindex;
}
